import { Route } from '@angular/router';
import { HelpCurationPage } from './help-curation-page/help-curation-page';

export const helpCurationRoutes: Route[] = [
  {
    path: '',
    component: HelpCurationPage,
    data: {
      title: 'help-curation.title',
      breadcrumb: 'navigation.help-curation',
    },
  },
];
